import { storeToRefs } from 'pinia';
import { useAccountStore } from '~/stores/accountStore';
import { useMeilisearchStore } from '~/stores/meilisearchStore';

type MeilisearchConfig = {
    meilisearch?: {
        searchApiKey?: string;
        searchApiKeyUid?: string;
    };
};

export default defineNuxtRouteMiddleware(async () => {
    if (!process.server) return; 

    const accountStore = useAccountStore();
    const meilisearchConfig = (useRuntimeConfig() as MeilisearchConfig).meilisearch || {};
    const { tenantToken } = storeToRefs(useMeilisearchStore());

    if (!accountStore.state.id) return;
    
    const apiKey = meilisearchConfig.searchApiKey;
    if (!apiKey) {
        return console.warn('Meilisearch API key not configured');
    }

    try {
        const { generateTenantToken } = await import('~/utils/tenantToken.server');
        const token = generateTenantToken(apiKey, accountStore.state.id, meilisearchConfig.searchApiKeyUid || '');
        tenantToken.value = token;
    } catch (error) {
        console.error('Failed to generate Meilisearch tenant token:', error);
    }
}); 
